import { en } from "./en";
import { registerCatalogs } from "./runtime";
import { en_GB } from "./locales/en-GB";
import { es } from "./locales/es";
import { pt_BR } from "./locales/pt-BR";
import { de } from "./locales/de";
import { fr } from "./locales/fr";
import { it } from "./locales/it";
import { pl } from "./locales/pl";
import { uk } from "./locales/uk";
import { ru } from "./locales/ru";
import { ko } from "./locales/ko";
import { tl } from "./locales/tl";
import { nl } from "./locales/nl";
import { sv } from "./locales/sv";
import { no } from "./locales/no";
import { da } from "./locales/da";
import { fi } from "./locales/fi";
import { el } from "./locales/el";
import { ro } from "./locales/ro";
import { hu } from "./locales/hu";
import { cs } from "./locales/cs";
import { id } from "./locales/id";
import { zh_Hans } from "./locales/zh-Hans";
import { sw } from "./locales/sw";
import { am } from "./locales/am";
import { vi } from "./locales/vi";
import { af } from "./locales/af";

registerCatalogs({
  en,
  "en-GB": en_GB,
  "es": es,
  "pt-BR": pt_BR,
  "de": de,
  "fr": fr,
  "it": it,
  "pl": pl,
  "uk": uk,
  "ru": ru,
  "ko": ko,
  "tl": tl,
  "nl": nl,
  "sv": sv,
  "no": no,
  "da": da,
  "fi": fi,
  "el": el,
  "ro": ro,
  "hu": hu,
  "cs": cs,
  "id": id,
  "zh-Hans": zh_Hans,
  "sw": sw,
  "am": am,
  "vi": vi,
  "af": af,
});

export { en };
